//angular components
import { Component, OnDestroy, OnInit } from '@angular/core';
//services
import { SharedGlobalService } from 'src/app/_core/services/api';
import { MetaService } from 'src/app/_core/services/meta.service';
import { AnalyticsTotals, RestResponse } from 'src/app/_shared/models';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';
@Component({
  selector: 'app-store-performance',
  templateUrl: './store-performance.component.html',
  styleUrls: ['./store-performance.component.scss']
})
export class StorePerformanceComponent implements OnInit, OnDestroy {
  isStorePerformanceError: boolean = false;
  isStorePerformanceReady: boolean = false;
  storePerformance: any;
    
  private subs = new Unsubscriber();

  constructor(private sharedGlobalService: SharedGlobalService,
              private meta: MetaService) { }

  ngOnInit(): void {
    this.getStorePerformance();
  }

  getStorePerformance() {
    this.subs.addSub = this.sharedGlobalService.getAnalyicsTotals().subscribe(
        (res: RestResponse) => {
          const companyCurrencyBase = <Array<AnalyticsTotals>>res.data;
          this.storePerformance = companyCurrencyBase;
          this.isStorePerformanceError = false;
          this.isStorePerformanceReady = true;
        },
        (err: RestResponse) => {
          this.meta.showNotification(err);
          this.isStorePerformanceError = true;
          this.isStorePerformanceReady = true;
        }
      );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
